const s = {
  name: "NewZealandDollar",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M11.7,14H10v12h2v-5.8l2.3,5.8H16V14h-2v5.8L11.7,14z"/>
		<path class="st0" d="M27,16c-0.5,0-1,0.5-1,1v0.8c0,0.4,0.2,0.7,0.6,0.9l1.8,0.9c1,0.5,1.7,1.5,1.7,2.7V23c0,1.3-0.8,2.4-2,2.8V27
			h-2v-1.2c-1.2-0.4-2-1.5-2-2.8v-1h2v1c0,0.5,0.5,1,1,1c0.5,0,1-0.5,1-1v-0.8c0-0.4-0.2-0.7-0.6-0.9l-1.8-0.9
			c-1-0.5-1.7-1.5-1.7-2.7V17c0-1.3,0.8-2.4,2-2.8V13h2v1.2c1.2,0.4,2,1.5,2,2.8v1h-2v-1C28,16.5,27.5,16,27,16z"/>
		<path class="st0" d="M17,16h3.5l-4,10H23v-2h-3.5l3.5-8.8V14h-6V16z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31.1,0,20,0z M2,20c0-9.9,8.1-18,18-18c9.9,0,18,8.1,18,18
			s-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as NewZealandDollar
};
